import OfferKz from '@/OfferKz.vue'
import OfferKzBx from '@/OfferKzBx.vue'
import DealerRegister from '@/components/DealerRegister.vue'
import DealersList from '@/components/DealersList.vue'
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store/index'

Vue.use(VueRouter)

const routes = [
    { path: '/', component: OfferKz, meta: { title: "Главная страница", isNotForDealer: true } },
    { path: '/kz-bx', component: OfferKzBx, meta: { title: "Главная страница", isNotForDealer: true } },
    { path: '/dealer-register', component: DealerRegister, meta: { title: "Регистрация дилера", isNotForDealer: true } },
    { path: '/dealers-admin', component: DealersList, meta: { title: "Список дилеров", isNotForDealer: true } },
    { path: '/:slug', name: 'offer-slug', component: OfferKz, meta: { title: "Коммерческое предложение", isNotForDealer: true } },
]

const router = new VueRouter({
    mode: 'history',
    routes
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
    const isNotForDealer = to.matched.slice().reverse().some(r => r.meta && r.meta.isNotForDealer);
    const isOnlyForDealer = to.matched.slice().reverse().some(r => r.meta && r.meta.isOnlyForDealer);

    let isDiler = store.getters['isDiler'];
    if ((!isOnlyForDealer || isDiler) && (!isNotForDealer || !isDiler)) {
        next();
    } else {
        next({ name: 'CheckFirm' });
    }
    // This goes through the matched routes from last to first, finding the closest route with a title.
    // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
    // `/nested`'s will be chosen.
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

    // Find the nearest route element with meta tags.
    const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle) {
        document.title = nearestWithTitle.meta.title;
    } else if (previousNearestWithMeta) {
        document.title = previousNearestWithMeta.meta.title;
    }

    // Remove any stale meta tags from the document using the key attribute we set below.
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

    // Skip rendering meta tags if there are none.
    if (!nearestWithMeta) return next();

    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags.map(tagDef => {
            const tag = document.createElement('meta');

            Object.keys(tagDef).forEach(key => {
                tag.setAttribute(key, tagDef[key]);
            });

            // We use this to track which meta tags we create so we don't interfere with other ones.
            tag.setAttribute('data-vue-router-controlled', '');

            return tag;
        })
        // Add the meta tags to the document head.
        .forEach(tag => document.head.appendChild(tag));

    next();
});

export default router